import { App } from '@capacitor/app';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { isNativeApp } from './platform';

/**
 * Capacitor ネイティブシェルの初期化（ステータスバー・スプラッシュ・Android 戻るボタン）
 * @param {{ navigate: (delta: number) => void }} handlers
 * @returns {() => void} cleanup
 */
export function initNativeShell({ navigate }) {
  if (!isNativeApp()) return () => {};

  StatusBar.setStyle({ style: Style.Light }).catch(() => {});
  StatusBar.setBackgroundColor({ color: '#ec4899' }).catch(() => {});
  SplashScreen.hide().catch(() => {});

  const backSub = App.addListener('backButton', ({ canGoBack }) => {
    if (canGoBack) {
      navigate(-1);
    } else {
      App.exitApp();
    }
  });

  return () => {
    backSub.then((handle) => handle.remove()).catch(() => {});
  };
}
